// extracted by mini-css-extract-plugin
export var standaloneTable = "_ew-0";
export var standaloneTableWithBodyFill = "_ew-1";
export var withExtraHeader = "_ew-2";